<template>
  <div>
    <h1 class="text-pagename text-xs-center">Refill credit</h1>
    <CashCreditForm :action_text="1"/>
    <v-card>
      <RefillCreditListTable/>
    </v-card>
  </div>
</template>

<script>

import axios from "axios";
import { mapState } from "vuex";
import CashCreditForm from "@/components/back-office/Rider/CashCreditForm";
import RefillCreditListTable from "@/components/back-office/Rider/RefillCreditListTable";
export default {
  data() {
    return {};
  },
  components: {
    CashCreditForm,
    RefillCreditListTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Rider",
        disabled: false,
        href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderinhouse'
        // href:
        //    "/weserve_admin_login/control/" +
        //   this.$route.params.province +
        //   "/rider/riderdashboard"
      },
      {
        text: "Refill credit",
        disabled: true,
        href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/refill_credit'
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {},
  computed: {}
};
</script>
